export enum TypeLink {
	LINK = "link",
	CUSTOM = "custom",
}

export const GOTO_OPTIONS = [
	{
		value: "no_branching",
		label: "no branching",
	},
	{
		value: "go_to_thank_you_page",
		label: "Go to thank you page",
	},
	{
		value: "question",
		label: "Go to next question",
	},
];

export const OPTIONS = [
	{
		value: "single_choice",
		label: "Single choice",
	},
	{
		value: "multi_choice",
		label: "Multiple choice",
	},
	{
		value: "short_answer",
		label: "Short answer",
	},
	{
		value: "date",
		label: "Date",
	},
];
